module.exports = __webpack_public_path__ + "c0d80505ed88ddaba887c91c770a36fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dashboard_highlight.png
// module id = 82
// module chunks = 0 1 2 3 4